import { SuccessStoryType } from "@/shared/types/common.types";
import { Typography } from "@graphy/ui";
import classNames from "classnames";
import Image from "next/image";

const SuccessStoriesMarqueeCard = ({
  successStory,
}: {
  successStory: SuccessStoryType;
}) => {
  const renderBasicInfo = () => (
    <>
      <div className="flex flex-col">
        <Typography
          size="BODY"
          fontWeight="font-semibold"
          colorClass="text-grey-4"
        >
          {successStory.name}
        </Typography>
        <Typography
          size="CAPTION"
          colorClass="text-grey-4"
          className="!leading-none"
        >
          {successStory.designation} | {successStory.company}
        </Typography>
      </div>
      <div className="flex flex-col text-right">
        <Typography
          size="CAPTION"
          colorClass="text-purple-3"
          fontWeight="font-semibold"
        >
          {successStory.highlight.main}
        </Typography>
        <Typography
          size="FOOTNOTE"
          colorClass="text-grey-3"
          className="!leading-none"
        >
          {successStory.highlight.subtext}
        </Typography>
      </div>
    </>
  );
  return (
    <div className="group/card pointer-events-none relative mx-3 flex w-[278px] flex-col sm:w-[400px]">
      <div
        className={classNames(
          "bottom-shadow-purple pointer-events-auto relative z-40 flex flex-grow flex-col gap-4 rounded-2xl border border-purple-2 bg-grey-0 p-4 transition sm:p-6"
        )}
      >
        <div className="flex items-start gap-4">
          <div className="relative h-20 w-20 overflow-hidden rounded-full bg-grey-4 sm:h-24 sm:w-24">
            <Image
              src={successStory.avatar}
              alt={`${successStory.name}'s avatar`}
              fill
            />
          </div>
          <div className="flex flex-1 flex-col gap-2">
            <div className="hidden flex-1 justify-between gap-2 sm:flex">
              {renderBasicInfo()}
            </div>
            <Typography size="BODY" colorClass="text-grey-4">
              {successStory.description}
            </Typography>
          </div>
        </div>
        <div className="flex flex-1 items-center justify-between gap-2 sm:hidden">
          {renderBasicInfo()}
        </div>
      </div>
    </div>
  );
};

export default SuccessStoriesMarqueeCard;
